<template>
  <div class="offer">
    <h1>Получить доступ к курсам</h1>
    <p>
      Оставьте заявку и наши специалисты свяжутся с Вами <br />
      для открытия доступа к обучающим курсам
    </p>
    <button @click="$emit('open')">Оставить заявку</button>
  </div>
</template>

<script>
export default {
  name: 'Offer'
}
</script>
